module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesRomantic.1e7f6f4.webp";